import Form from './Form';

const AddItemPage = () => {
    return (
        <div id="add-item-page">
            <h1 className="dash-h1">Add New Product</h1>
            <Form />
        </div>
    );
};

export default AddItemPage;